import { connect } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';
import { RoomFacilitiesHintFactory } from './RoomFacilitiesHintFactory';
import { getHotelFacilitiesRoomForSearcher } from '../../store/hotel';

const mapStateToProps = (state) => ({
  items: getHotelFacilitiesRoomForSearcher(state),
  isMobile: getIsMobile(state),
});

export default connect(mapStateToProps)(RoomFacilitiesHintFactory);
